import React from "react";
import "../../styles/SalesFunnel.css";
import awareness from "../../assets/icons/front-end.png";
import conversion from "../../assets/icons/web-programming.png";
import retention from "../../assets/icons/responsive.png";

const SFservice = () => {
  return (
    <div className="sf-services">
      <h3>Services Offered by a Branding Agency in Noida</h3>
      <p className="sf-description">
        A dependable Branding Agency in Noida gives a huge range of services
        designed to help corporations construct an effective brand identity.
        These offerings go beyond fundamental layout and awareness of strategic
        logo improvement.
      </p>
      <div className="sf-cards-wrapper">
        <div className="sf-service-card">
          <div className="sf-icon">
            <img className="icon-img" src={awareness} alt="Awareness Stage" />
          </div>
          <h3>Brand Strategy Development</h3>
          <p>
            Before creating visual elements, the{" "}
            <b>top creative agency in Noida </b>
            conducts in-depth studies to comprehend your business desires,
            audience, and market competition. This enables growing a strong logo
            method that defines your brand positioning.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={conversion}
              alt="Conversion Optimization"
            />
          </div>
          <h3>Logo and Brand Identity Design</h3>
          <p>
            A professionally designed logo is the foundation of any brand.
            Through expert brand and logo identification design, businesses can
            create a unique, visible identification that represents their values
            and character.
          </p>
        </div>
        <div className="sf-service-card">
          <div className="sf-icon">
            <img
              className="icon-img"
              src={retention}
              alt="Customer Retention"
            />
          </div>
          <h3>Brand Messaging and Storytelling</h3>
          <p>
            Successful brands tell effective tales. An expert branding agency in
            Noida helps companies craft compelling logo messages that connect
            emotionally with their target market.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SFservice;
